module.exports = __webpack_public_path__ + "static/scale-model-of-the-daniels-and-fisher-tower-in-denver-colorado-10b343bc4311a382483954d58f98fd5b.png";